
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { isForcedMotionValue } from '../../../motion/utils/is-forced-motion-value.mjs.js';
import { isMotionValue } from '../../../value/utils/is-motion-value.mjs.js';

function scrapeMotionValuesFromProps(props) {
    var style = props.style;
    var newValues = {};
    for (var key in style) {
        if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
            newValues[key] = style[key];
        }
    }
    return newValues;
}

export { scrapeMotionValuesFromProps };
//# sourceMappingURL=scrape-motion-values.mjs.js.map
